// extracted by mini-css-extract-plugin
export var borderRadius = "_62-4";
export var large = "_62-3";
export var logoContainer = "_62-0";
export var nameLogo = "_62-2";
export var small = "_62-1";